import { createContext, useContext } from 'react'

import { CatalogBrandsProductsData, FilterData } from '@/entities/catalog-brands'

import { TServerSection } from '@/shared/types/deprecated-types'

type CatalogBrandsInitialData = {
	initialFilterData: FilterData | null
	initialProductsData: CatalogBrandsProductsData | null
	initialResolvedUrl: string
	initialDetailedSectionData?: TServerSection | null
}

const CatalogBrandsInitialDataContext = createContext<CatalogBrandsInitialData>({
	initialFilterData: null,
	initialProductsData: null,
	initialResolvedUrl: ''
})

export const CatalogBrandsInitialDataProvider = CatalogBrandsInitialDataContext.Provider
export const useCatalogBrandsInitialData = () => useContext(CatalogBrandsInitialDataContext)
